<div class="uk-section uk-section-primary">
  <div class="uk-container">
    <h1 class="uk-heading" style="text-align:center">
      <span>Getting in touch</span>
    </h1>
    <div class="uk-flex uk-flex-center uk-animation-toggle">
      <a href="https://www.linkedin.com/in/antoniosanagnostou/" class="uk-button uk-button-default uk-button-large uk-button-primary  uk-animation-slide-bottom-small">Find me on LinkedIn</a>
    </div>
  </div>
</div>

